module.exports = __webpack_public_path__ + "img/statistics-icon.31837b9f.svg";